
import React from 'react';
import { useDispatch } from 'react-redux';
import styles from './Modals.css';
import { Title } from '../title';
import { ClickElement } from '../form';
import { ModalsWrapper } from './';
import {
  changeUserShowMobileItemInAppPersistent,
} from '../../ducks';

export const ItemOpenPrefModal = () => {
  const dispatch = useDispatch();

  return(
    <ModalsWrapper>
      <Title Tag='h1'>
          Wij hebben ook een app!
      </Title>
      <p className='paragraph'>
        {/* eslint-disable-next-line max-len */}
          Geef hier onderaan hoe je directe items op Dumpert wilt openen
      </p>
      <div className={styles['button-bar']}>
        <ClickElement
          tertiary
          ElementType='button'
          text='Items openen in app'
          onClick={() => {
            dispatch(changeUserShowMobileItemInAppPersistent(true));
          }}
        />
        <ClickElement
          primary
          ElementType='button'
          text='Items openen in browser'
          onClick={() => {
            dispatch(changeUserShowMobileItemInAppPersistent(false));
          }}
        />
      </div>
    </ModalsWrapper>
  ) ; 
};